import React, { useContext, useMemo } from "react";

import "./EUMRVPortStays.scss";

import CustomTable from "../../../../../../common/customTable/CustomTable";
import {
	DerogationIceClassColumns,
	EUMRV_PORTSTAYS_HEADERS,
	ETS_COLUMN_KEYS,
	MRV_COLUMN_KEYS
} from "../../../../../../constants/CustomTableHeaders";
import { FeatureType } from "../../../../../../constants/FeatureToggles";
import { ClaimsContext } from "../../../../../../services/ClaimsService";

const DerogationIceClass = ({ data }) => {
	
	const columnsData = (() => {
		const idsToExclude =   MRV_COLUMN_KEYS ;
		return DerogationIceClassColumns.filter((col) => !idsToExclude.includes(col.accessorKey));
	})();

	return (
		<div className="mt-4 eu_mrv_ps">
			<CustomTable
				columnsData={columnsData}
				renderTableData={data || []}
				customProps={{
					header: EUMRV_PORTSTAYS_HEADERS.ICE_CLASS,
					enableSort: false,
					tableName: "emissions-report",
					maxHeight: "30vh",
				}}
			/>
		</div>
	);
};

export default DerogationIceClass;
